@if (show$ | async) {
	<div id="loader-block"></div>
	<div id="loader-spin">
		<div class="spinner-border spinner-loader-border text-info" role="status">
			<span class="vms-only">{{ 'g.loading' | translate }}...</span>
		</div>
	</div>
}
